import {ApiResponse} from '../../api/api-response';
import {FormGroup} from '@angular/forms';

export class FormError {

  private errors: any = {};

  constructor() {
  }

  clearErrors(): void {
    this.errors = {};
  }

  setFormGroupErrors(formGroup: FormGroup): void {
    for (const field in formGroup.controls) {
      const control = formGroup.controls[field];
      if (control.errors) {
        for (const error in control.errors) {
          if (control.errors[error]) {
            if (!this.errors[field]) {
              this.errors[field] = [];
            }
            this.errors[field].push('formError.' + error);
          }
        }
      }
    }
  }

  setApiResponseErrors(apiResponse: ApiResponse): void {
    const errors = apiResponse.getErrors();
    if (errors) {
      for (const error of errors) {
        if (!this.errors[error.propertyPath]) {
          this.errors[error.propertyPath] = [];
        }
        this.errors[error.propertyPath].push(error.message);
      }
    }
  }

  getErrors(fieldName: string): string[] {
    return this.errors[fieldName] ?? [];
  }
}
